<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" :class="'sidebar-logo-link' + (tenantId === 4039 ? ' sidebar-logo-4039' : '')" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo-collapse">
        <h1 v-else class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" :class="'sidebar-logo-link' + (tenantId === 4039 ? ' sidebar-logo-4039' : '')" to="/" :style="{ textAlign: tenantId === 18182 ? 'center' : '' }">
        <img v-if="tenantId === 18182" :src="logo" class="sidebar-logo" style="width: auto;padding: 5px 30px 5px 0;">
        <img v-else-if="tenantId === 4039" :src="logo" class="sidebar-logo" style="width: auto;padding: 5px 30px 5px 18px;">
        <img v-else-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import logo4 from '@/assets/logo/logo4.png'
import logo5 from '@/assets/logo/logo5.png'
// import logo100 from '@/assets/logo/logo_100.png' // ubi
import logo100 from '@/assets/logo/logo_100.svg' // ubi
import logo499 from '@/assets/logo/logo_499.png' // ubi
import logo18182 from '@/assets/logo/logo_18182.png' // ubi
import logo4039 from '@/assets/logo/logo_4039.png'
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'tenantId',
      'userInfo'
    ]),
    logo() {
      if (this.tenantId === 100) {
        // ubi
        return logo100
      } else if (this.tenantId === 499) {
        return logo499
      } else if (this.tenantId === 18182) {
        return logo18182
      } else if (this.tenantId === 4039) {
        return logo4039
      }
      return this.$store.state.settings.isUIPersonalized ? logo5 : logo4
    }
  },
  data() {
    return {
      title: 'CargoWare'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
@import '~@/styles/element-variables.scss';
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: $--color-primary;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      height: 100%;
      padding: 5px 52px 10px 18px;
    }
    & .sidebar-logo-collapse {
      width: 145px;
      height: 55px;
      margin-left: 18px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }

  .sidebar-logo-4039 {
    background: #f2f2f2;
  }
}

// 中文样式
#app.zh {
  .sidebar-logo-container {
    & .sidebar-logo-link {
      & .sidebar-logo {
        width: $sideBarWidth;
      }
    }
  }
}

// 英文样式
#app.en {
  .sidebar-logo-container {
    & .sidebar-logo-link {
      & .sidebar-logo {
        width: $enSideBarWidth;
      }
    }
  }
}
</style>
